var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#261F56",
    d: "M8.336 3.892a4.105 4.105 0 1 0 0 8.209 4.105 4.105 0 0 0 0-8.21Zm0 6.77a2.665 2.665 0 1 1 0-5.33 2.665 2.665 0 0 1 0 5.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#261F56",
    d: "M11.632.05C10.16-.02 6.514-.016 5.04.05 3.745.11 2.603.424 1.683 1.344.144 2.883.341 4.956.341 7.997c0 3.112-.173 5.138 1.342 6.653 1.544 1.544 3.648 1.342 6.653 1.342 3.683 0 7.713.353 7.947-4.7.07-1.472.066-5.117 0-6.59-.132-2.81-1.64-4.512-4.65-4.652Zm2.33 13.582c-1.01 1.009-2.409.919-5.647.919-3.333 0-4.67.049-5.646-.93-1.124-1.117-.92-2.913-.92-5.634 0-6.65.381-6.565 6.556-6.565l.03.02c6.622 0 6.554.429 6.554 6.555.001 3.294.064 4.639-.928 5.635Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#261F56",
    d: "M12.604 4.689a.96.96 0 1 0 0-1.918.96.96 0 0 0 0 1.918Z"
  })));
};
export default SvgInstagram;